enum FontWeights {
	Bold = '700',
	Normal = '400',
}

export default FontWeights;
